import { post } from "../../api/HttpClient.js";
import { BASE_URL, CreateNewMeeting_url, GetParticipantsForMeeting_url, MeetingRoomListAndInfo_url ,NotificationList_url,
    NotificationToggleStatus_url, MarkAsReadNotification_url, BookingConfirmation_url, ScheduledBookingConfirmation_url
} from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";

// NewMeetingModal APIs- start

export function CreateNewMeeting_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${CreateNewMeeting_url}`,
        params: requestParams,
    });
}

export function CreateNewMeetingTimeGrid_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.TeamMemberGuId = "";
    requestParams.IsGuest = 0;
    requestParams.Tags = "";
    return post({
        url: `${BASE_URL}${MeetingRoomListAndInfo_url}`,
        params: requestParams,
    });
}

export function FetchSpotsByZone_api(url, requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${url}`,
        params: requestParams,
    });
}

export function GetParticipantsForMeeting_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${GetParticipantsForMeeting_url}`,
        params: requestParams,
    });
}
// NewMeetingModal APIs- end

// Notification APIs- start

export function NotificationList_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${NotificationList_url}`,
        params: requestParams,
    });
}
export function NotificationToggleStatus_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${NotificationToggleStatus_url}`,
        params: requestParams,
    });
}

export function MarkAsReadNotification_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${MarkAsReadNotification_url}`,
        params: requestParams,
    });
}

export function BookingConfirmation_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${BookingConfirmation_url}`,
        params: requestParams,
    });
}

export function ScheduledBookingConfirmation_api(requestParams) {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${ScheduledBookingConfirmation_url}`,
        params: requestParams,
    });
}
// Notification APIs- end
